import React, { useState, useEffect, useRef} from 'react';
import '../css/CompanyHouseDetails.css'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
    fetchCompanyOfficers,
    setViewChouseDetails
  } from '../slices/chouseSlice.js'
import {formatDate, Months} from '../helpers/dates.js'
import chtypes from '../helpers/chouseenumerated.js'

function CompanyHouseOfficers (props) {
    const officers = useSelector(state => state.chouse.officers, shallowEqual)
    const [officerfilter,setOfficeFilter] = useState(false)

    const CreateCorrespondanceAddress = (item) => {

        const addr = item.address
        let address = ""
        
        if((addr.care_of??"") > "")
            address = `Care Of ${addr.care_of}`;
        if((addr.premises??"") > "" ) {
            if(address > "") address += ", "
            if((addr.address_line_1??"") > "" )
                address += `${addr.premises} ${addr.address_line_1}`
            else
                address += addr.premises;
    
        }
        else if((addr.address_line_1??"") > "")
            if(address > "")
                address += `, ${addr.address_line_1}`
            else    
                address = addr.address_line_1
    
        if((addr.address_line_2??"") > "")
            address += `, ${addr.address_line_2}`

        if((addr.locality??"") > "")
            address += `, ${addr.locality}`

        if((addr.region??"") > "")
            address += `, ${addr.region}`
        if((addr.country??"") > "")
            address += `, ${addr.country}`

        if((addr.postal_code??"") > "")
            address += `, ${addr.postal_code}`
        return address;
    }

    const GetOfficerRole = (role) => {
        if(typeof role === 'undefined' || (role??"") === "")
            return "";
        const officer = chtypes.officer_role[role]??""
        return officer;
    }

    const officerFilter = (item) => {
        if(!officerfilter)
            return item
        if(officerfilter && typeof item.resigned_on === 'undefined')
            return item
        return null
    }

    return (
        <>
            <div>
                <h2 className="heading-medium" style={{marginBottom: '0'}}>Filter officers</h2>
                    <label for="show-filing-type" className="block-label selection-button-checkbox selected">
                        <input id="show-filing-type" type="checkbox" onClick={() => setOfficeFilter((state)=> !state)}/>
                        Current officers
                    </label>
            </div><br/>

        {officers.filter(item => officerFilter(item)).map((item,index) => {

            return (
            <div class='officertable'>
            <table key={`table_${index}_off`}>
                <tbody>
                    <tr>
                        <td colspan='4'>
                            <h2>{item.name}</h2>
                            <p>Correspondence address<br/>
                            <strong>{ CreateCorrespondanceAddress(item) }</strong></p>
                        </td>
                    </tr>
                    <tr keys={ `off_${index}_r1` } >
                        <td>Role <span class={ `${typeof item.resigned_on === 'undefined'?'active-status':'resigned-status'}` } >{`${typeof item.resigned_on === 'undefined'?'ACTIVE':'RESIGNED'}`}</span><br/>
                        <strong>{GetOfficerRole(item?.officer_role)}</strong></td>
                        <td class={`${typeof item.date_of_birth === 'undefined' ?'hidden':''}`}>Date of birth<br/>
                        <strong>{`${Months(item?.date_of_birth?.month)} ${item?.date_of_birth?.year.toString()}`}</strong></td>
                        <td>Appointed On<br/>
                        <strong>{formatDate(item.appointed_on??null)}</strong>
                        </td>
                        <td class={`${typeof item.resigned_on === 'undefined'?'hidden':'bold'}`} >Resigned On<br/>
                        <strong>{formatDate(item.resigned_on??null)}</strong></td>
                    </tr>
                    <tr keys={`off_${index}_r2`} >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <hr/>
            </div>
        )})}
        </>
    )

}

export default CompanyHouseOfficers
